module.exports = __webpack_public_path__ + "d60cf73a2ba97bf0aeb8a0437066065f.pdf";